import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";

import { InputSearchIconUI } from "./styles/style";

interface InputFieldIcons {
  iconStart: any;
  InputProps: any;
  secondIcon?: any;
  value?: any;
  placeholder?: string;
  elementRef?: any;
  hideCrossIcon?: boolean;
}

type AllProps = InputFieldIcons;

const FormInputFieldIcon: React.FC<AllProps> = ({
  iconStart,
  InputProps,
  secondIcon,
  placeholder,
  elementRef,
  hideCrossIcon,
  ...props
}: AllProps) => {
  // allow spaces in input — do not block space key

  const AdornmentTypes: any = hideCrossIcon ? { endAdornment: null } : {};

  return (
    <Box>
      <TextField
        {...props}
        variant="standard"
        placeholder={placeholder}
        inputRef={elementRef}
        slotProps={{
          input: {
            onKeyDown: (e: React.KeyboardEvent) => {
              if (e.key === "Enter") {
                e.stopPropagation();
              }
            },
            ...InputProps,
            ...AdornmentTypes,
            startAdornment: iconStart ? (
              <>
                <InputAdornment position="start" sx={InputSearchIconUI}>
                  {iconStart}
                </InputAdornment>
                {secondIcon && (
                  <InputAdornment position="start" sx={InputSearchIconUI}>
                    {secondIcon}
                  </InputAdornment>
                )}
              </>
            ) : (
              secondIcon && (
                <InputAdornment position="start" sx={InputSearchIconUI}>
                  {secondIcon}
                </InputAdornment>
              )
            ),
          },
        }}
      />
    </Box>
  );
};

export default FormInputFieldIcon;
